'use client';

import clsx from 'clsx';
import type { ForwardedRef } from 'react';
import { Form as RACForm, type FormProps as RACFormProps } from 'react-aria-components';
import { forwardRef } from '../../forward-ref.js';
import { withStyleProps } from '../../with-style-props.js';
import type { AriaLabelingProps, CommonProps } from '../types.js';

export interface FormProps
  extends
    CommonProps,
    AriaLabelingProps,
    Pick<
      RACFormProps,
      | 'action'
      | 'validationErrors'
      | 'encType'
      | 'method'
      | 'target'
      | 'autoComplete'
      | 'autoCapitalize'
      | 'children'
      | 'onSubmit'
      | 'onReset'
      | 'onInvalid'
    > {}

function Form({ children, UNSAFE_className, UNSAFE_style, ...props }: FormProps, ref: ForwardedRef<HTMLFormElement>) {
  return (
    <RACForm {...props} className={clsx('cim-form', UNSAFE_className)} style={UNSAFE_style} ref={ref}>
      {children}
    </RACForm>
  );
}

/**
 * A group of inputs that allows users to submit data to a server.
 *
 * See [forms guide](https://ui.cimpress.io/dev-guides/forms/).
 */
const _Form = withStyleProps(forwardRef(Form), 'Form');

export { _Form as Form };
